import { forwardRef, InputHTMLAttributes } from 'react'

type Props = InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className = '', invalid, ...props },
  ref
) {
  const base = 'border rounded px-3 py-2 text-sm w-full'
  const invalidCls = invalid ? 'border-danger' : ''
  return <input ref={ref} className={`${base} ${invalidCls} ${className}`} {...props} />
})

